import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

type PasswordResetEmailResponse = {
  success?: boolean;
  email?: string;
  error?: string;
  message?: string;
};

type PasswordResetError = {
  error: true;
  message: string;
};

type PasswordResetResult =
  | {
      error: false;
      message: string;
    }
  | PasswordResetError;

type PasswordResetEmailResult =
  | {
      error: false;
      email: string;
    }
  | PasswordResetError;

const getApiErrorMessage = (error: unknown, fallbackMessage: string): string => {
  if (axios.isAxiosError<PasswordResetEmailResponse>(error)) {
    return error.response?.data?.error || error.response?.data?.message || fallbackMessage;
  }

  return fallbackMessage;
};

export const requestPasswordResetEmail = async (cpf: string): Promise<PasswordResetEmailResult> => {
  try {
    const response = await axios.post<PasswordResetEmailResponse>(`${API_URL}/forgot-password/email`, { cpf });

    if (response.data?.success && response.data.email) {
      return {
        error: false,
        email: response.data.email,
      };
    }

    return {
      error: true,
      message: response.data?.error || response.data?.message || "Não foi possível localizar o usuário informado.",
    };
  } catch (error: unknown) {
    return {
      error: true,
      message: getApiErrorMessage(error, "Não foi possível localizar o usuário informado."),
    };
  }
};

export const requestPasswordReset = async (cpf: string, email: string): Promise<PasswordResetResult> => {
  try {
    const response = await axios.post(`${API_URL}/forgot-password`, { cpf, email });

    if (response.status === 200) {
      return {
        error: false,
        message: "Solicitação enviada com sucesso. Verifique seu e-mail.",
      };
    }

    return {
      error: true,
      message: "Erro ao solicitar redefinição de senha.",
    };
  } catch (error: unknown) {
    return {
      error: true,
      message: getApiErrorMessage(error, "Erro ao conectar-se ao servidor."),
    };
  }
};
